import
{
    useL10n
} from "@ews/react-localization-context";

import
{
    LicenseType,
    permissionAllowed,
    SystemRTM,
    UserPermissions
} from "@ews/react-data";

import
{
    addressTypeFuse,
    deviceType,
    Event,
    eventDetails,
    eventGetSymbol,
    eventRTMCategory,
    faultsDetails,
    getLogicalAddress,
    helpText,
    ioText,
    isGroup,
    isValidDeviceNumber,
    loopType,
    NumberGroup,
    RTMCategory,
    slotIdentifier,
    timestampToDate
} from "@ews/zlt-events";

import { IonCard, IonItem, IonList, IonModal, IonPopover, IonText, IonTitle } from "@ionic/react";

import { useIsMobile } from "../../Responsive";

import Icon, { IconName } from '@ews/react-icons';

import React, { ReactNode, useRef, useState } from "react";
import { useAuthorization } from "../../Authorization";
import { MenuComponent } from "../../Group/GruppList/components/Menu";
import { PositionSide } from "../../List/types";
import Operate, { OperateSidebarProps, OperateTarget, validOperations } from "../../Navigation/Sidebar/Operate";
import { SystemElement, SystemGroup } from "../../ReactData/system";
import { ReactClickEvent } from "../../types";
import eventItemStyle from './EventItem.module.scss';

import { useHasLicense } from "../../HasLicense";
import { useMyPermissions } from "../../Login/LoginProvider";
import LongPress from "../../LongPress";
import { useNamedRoutes } from "../../NamedRoutes";

type EventItemNewProps = {
    rtm: SystemRTM[];
    title?: string;
    className?: string,
    children?: React.ReactNode;
};

type _SystemRTM = (SystemRTM & { index: number; })[];

function maxScreenHeight(height: number, y: number, side: PositionSide, margin: number = 10): number
{
    return (side === "bottom" ? (height - y) : y) - margin;
}

function pxToPercent(childSize: number, parentSize: number): number
{
    return Math.round((childSize / parentSize) * 100);
}

const getLastEvent = (rtm: SystemRTM[]) =>
{
    let index = -1;

    const lastTime = Math.max(...rtm.map(rtm => rtm.timestamp));

    const lastEvent = rtm.filter((event, _index) =>
    {
        const isLastEvent = event.timestamp === lastTime;
        if (isLastEvent) {
            index = _index + 1;
        }
        return isLastEvent;
    }) as _SystemRTM;

    if (lastEvent.length) {
        lastEvent[0].index = index;
        return lastEvent[0];
    }
    return null;
};


export const LastAlarmView: React.FC<{ rtm: SystemRTM[]; }> = ({
    rtm
}) =>
{
    const lastAlarm = getLastEvent(rtm);
    const { translate: t, formatDate } = useL10n();

    if (!lastAlarm) return <></>;

    const { timestamp, groupText, elementText, eventKindType, softwareDeviceType } = lastAlarm;

    const symbol = getEventIcon(lastAlarm);
    const { translationKey } = eventDetails(eventKindType!, softwareDeviceType!);
    const label = getLogicalAddress(lastAlarm as any);

    const date = timestampToDate(timestamp!);

    return <IonItem color={"secondary"} className={eventItemStyle["list-alarm-card"]}>
        <div className={eventItemStyle["list-alarm-grid"]}>
            <section>
                <div className={eventItemStyle["list-alarm-card-icon"]}>
                    <IonText>{`${label}`}</IonText>
                    <Icon height={30} width={30} icon={symbol as IconName} />
                    <IonText>{`${lastAlarm.index}. ${t("[SID_MNU_HK_ONE_ALARM]")}`}</IonText>
                </div>

                <section>
                    <section className={eventItemStyle["list-alarm-card-detail"]}>
                        <div>
                            <div> <IonText>{`${t(translationKey)}`}</IonText></div>
                            <div> <IonText>{`${groupText}`}</IonText></div>
                            <div> <IonText>{elementText}</IonText></div>
                        </div>
                        <div className={eventItemStyle["list-alarm-card-time"]}>
                            <div>
                                <IonText>{formatDate(date, { "timezone": 'UTC', "dateStyle": "medium" })}</IonText>
                            </div>
                            <div>
                                <IonText> {formatDate(date, { "timeZone": 'UTC', "timeStyle": "medium" })}</IonText>
                            </div>
                        </div>
                    </section>
                </section>
            </section>
        </div>

    </IonItem>;
};


type EventDetailsProps = {
    event: SystemRTM,
    permissions: UserPermissions;
};

const addressTypeLoopInput = 0x0002;
const addressTypeLoopOutput = 0x0003;

const EventDetails: React.FC<EventDetailsProps> = ({
    event,
    permissions

}) =>
{
    const { translate: t } = useL10n();
    const [expand, setExpand] = useState(false);
    const { eventKindType, numberGroup,
        element, zone,
        panelNumber, panelName, isNetwork,
        elementText, groupText,
        planText, alarmText,
        backplaneNumber, busIdentifier, softwareDeviceType,
        loopElement, posLoopElement, mainAddress, subAddress, addressType,
        errorCode, measurement, unknownElement
    } = event;

    //const details = eventDetails(eventKindType!);
    const helpTexts = helpText(eventKindType, errorCode);
    //const eventCategory = details.filter;
    const slotNumber = slotIdentifier(backplaneNumber, busIdentifier); //getSlotNumber(backplaneNumber, busIdentifier);
    const measureText = faultsDetails(measurement) || {};
    const errorText = faultsDetails(errorCode) || {};

    const isGroupEvent = isGroup({
        zone: zone!,
        element: element!
    });

    const isFloodingZone = numberGroup === NumberGroup.FloodingZone;

    if (unknownElement) {
        return <div>
            <IonText color={'medium'} className={eventItemStyle["event-fontsize-title"]}>{t('[REACT_DIALOG_NO_CSV]')}</IonText>
        </div>;
    }

    return <>
        <div>
            <IonText color={'medium'} className={eventItemStyle["event-fontsize-title"]}>{isFloodingZone ? elementText : groupText}</IonText>
        </div>
        {!isGroupEvent && !isFloodingZone &&
            <div>
                <IonText color={'medium'} className={eventItemStyle["event-fontsize-title"]}>{elementText}</IonText>
            </div>
        }
        {!!expand &&
            <>
                {permissionAllowed(permissions.permitAccessLevel2!) &&
                    <>
                        {isNetwork &&
                            <div>
                                <IonText color={'medium'} className={eventItemStyle["event-fontsize-title"]}>{t('TLN:')} {panelNumber}{panelName && ', '}{panelName}</IonText>
                            </div>
                        }

                        {permissionAllowed(permissions.permitAccessLevel3!) &&
                            <>
                                <div>
                                    <IonText color={'medium'} className={eventItemStyle["event-fontsize-title"]}>
                                        {isFloodingZone ? <>
                                            {t('[SID_EXT_SYS_DEV_SH]')}: {zone} {groupText}
                                        </>
                                            : Boolean(slotNumber) && <>{slotNumber} {Boolean(softwareDeviceType) && <>{t(deviceType(softwareDeviceType))}-x</>}
                                                <>
                                                    <span>, </span>
                                                    {([addressTypeLoopInput, addressTypeLoopOutput].includes(addressType)) ? <>
                                                        {isValidDeviceNumber(posLoopElement!) && <>
                                                            {t('[SID_DETAILS_POS]')}: {posLoopElement}{isValidDeviceNumber(mainAddress!) && <>,<span> </span>
                                                                {t('[SID_DETAILS_ADDR]')}: {mainAddress}{isValidDeviceNumber(subAddress!) && <>,<span> </span>
                                                                    {t('[SID_DETAILS_SUB]')}: {subAddress}
                                                                </>}
                                                            </>}
                                                        </>}
                                                    </> : <>
                                                        {Boolean(softwareDeviceType && isValidDeviceNumber(addressType || 0)) &&
                                                            <>
                                                                <>{t(ioText(softwareDeviceType!, addressType!, mainAddress!) || "")}</>
                                                                <>{addressTypeFuse(addressType) && `${t('[SID_DETAILS_FUSE]')}${mainAddress}`}</>
                                                            </>
                                                        }
                                                    </>
                                                    }
                                                </>
                                            </>
                                        }
                                    </IonText>
                                </div>
                                {isValidDeviceNumber(loopElement || 0) && <div>
                                    <IonText color={'medium'} className={eventItemStyle["event-fontsize-title"]}>{t(loopType(loopElement))}</IonText>
                                </div>}
                            </>
                        }

                        {(measureText.translationKey || errorText.translationKey) &&
                            <div>
                                {measureText.translationKey && <IonText color={'medium'} className={eventItemStyle["event-fontsize-title"]}>{t("[SID_DETAILS_DET_VAL]")}: {t(measureText.translationKey)}</IonText>}
                                {(measureText.translationKey && errorText.translationKey) && <>, </>}
                                {errorText.translationKey && <IonText color={'medium'} className={eventItemStyle["event-fontsize-title"]}>{t(errorText.translationKey || "")}</IonText>}
                            </div>
                        }
                    </>
                }
                <>{!permissionAllowed(permissions.permitAccessLevel3!) &&
                    <>
                        {planText &&
                            <div>
                                <IonText color={'medium'} className={eventItemStyle["event-fontsize-title"]}>{planText}</IonText>
                            </div>
                        }
                        {alarmText &&
                            <div>
                                <IonText color={'medium'} className={eventItemStyle["event-fontsize-title"]}>{alarmText}</IonText>
                            </div>
                        }
                        {helpTexts &&
                            <>
                                <div>
                                    <IonText color={'medium'} className={eventItemStyle["event-fontsize-title"]}>{t(helpTexts.helpTextLine1)}</IonText>
                                </div>
                                <div>
                                    <IonText color={'medium'} className={eventItemStyle["event-fontsize-title"]}>{t(helpTexts.helpTextLine2)}</IonText>
                                </div>
                                <div>
                                    <IonText color={'medium'} className={eventItemStyle["event-fontsize-title"]}>{t(helpTexts.helpTextLine3)}</IonText>
                                </div>
                            </>
                        }
                    </>
                }</>
            </>
        }
        <div style={{ paddingBottom: ".5em" }} className={eventItemStyle["align-right"]} onClick={() => setExpand(!expand)}>
            <IonText color={'medium'} >{t(expand ? 'Hide Details' : 'Show details')}</IonText>
        </div>
    </>;

};

export const getEventIcon = (rtm: SystemRTM): IconName =>
{
    const { eventKindType, zone, element } = rtm;
    if (isGroup({ zone, element }) && eventRTMCategory(eventKindType) === RTMCategory.TestCondition) {
        if (rtm.errorCode === -1) return "Test_alarm_L_red";
    }
    return eventGetSymbol(eventKindType, { zone, element });

};

const EventItem: React.FC<EventItemNewProps> = ({
    rtm,
    title,
    className,
    children
}) =>
{
    const mobileView = useIsMobile();
    const permissions = useMyPermissions();
    const { translate: t, formatDate } = useL10n();
    const { generate } = useNamedRoutes();

    const hasOperationAndPushLicense = useHasLicense(LicenseType.OPERATE_AND_NOTIFICATION);
    const hasPlanLicense = useHasLicense(LicenseType.PLAN_VIEW);

    rtm.sort((l, r) => l.timestamp! - r.timestamp!);

    const { authorizationLevel } = useAuthorization();
    const ContextMenuElement = mobileView ? IonModal : IonPopover;
    const [ContextMenu, setContextMenu] = useState<{ contextMenu?: ReactNode, event?: ReactClickEvent; }>({});

    const contextDirection = useRef<PositionSide>("bottom");
    const contextMaxHeight = useRef<number | null>(1050);

    const presentOptions = (target: SystemElement | SystemGroup, e?: ReactClickEvent) =>
    {
        const isOnPlanView = (target as SystemElement).systemPlanId && hasPlanLicense;
        const customLinks: OperateSidebarProps["customLinks"] = [];
        const [rtm] = target.rtm!;

        if (isOnPlanView) {
            customLinks.push({
                title: t('[REACT_REDIRECT_PLAN]'),
                link: generate("system:plan", { id: target.systemId!, planId: (target as SystemElement).systemPlanId }),
                icon: <Icon icon="plan" />
            });
        }


        if (permissionAllowed(permissions.permitAccessLevel3!) && rtm.providesMeasurements) {
            const query: {
                id?: string;
                numberGroup?: string,
                group?: string,
                element?: string;
            } = {
                numberGroup: `${target.numberGroup}`,
                id: target.systemId,
            };

            if (!("elements" in target)) {
                query.element = `${target.id}`;
                query.group = `${(target as SystemElement).groupId}`;


            } else {
                query.group = `${(target as SystemGroup).id}`;

            }
            customLinks.push({
                title: `${t("COM_FACPMANAGEMENT_FACP_FIELD_MEASUREMENT_BUTTON")}`,
                link: generate("system:analoguevalues", query),
                icon: <Icon icon="event_memory" />
            });
        }


        const contextMenu = <Operate
            target={target}
            onMenuToggle={dismissOptions}
            customLinks={customLinks}
        />;

        const { clientY, view } = e!.nativeEvent as PointerEvent;
        const screenHeight = view?.innerHeight || 0;
        const heightPercent = pxToPercent(clientY, screenHeight);
        const side = heightPercent >= 70 ? "top" : "bottom";

        if (e?.cancelable) e?.preventDefault();
        setContextMenu({ contextMenu, event: e });

        contextDirection.current = side as PositionSide;
        contextMaxHeight.current = maxScreenHeight(screenHeight, clientY, side as PositionSide);
    };

    const dismissOptions = () =>
    {
        setContextMenu({});
    };

    return <>
        <ContextMenuElement
            reference="event"
            side={contextDirection.current}
            event={ContextMenu.event?.nativeEvent}
            initialBreakpoint={mobileView ? .6 : undefined}
            // className={mobileView ? listStyle.menu : ''}
            isOpen={Boolean(ContextMenu.contextMenu)}
            onDidDismiss={dismissOptions}
            keepContentsMounted={true}
            style={{ alignItems: "start", "--max-height": `${contextMaxHeight.current}px `, }}
        >
            {ContextMenu.contextMenu}
        </ContextMenuElement>
        <IonList lines={mobileView ? "full" : 'none'} className={`${eventItemStyle['event-main-list-container']} ${className || ""}`}>
            <IonItem className={eventItemStyle["list-title-container"]}>
                <IonTitle color='primary'>{t(title || "")} [{rtm.length}]</IonTitle>
            </IonItem>
            <IonList lines="full" className={`${eventItemStyle[`event-list-container-${mobileView ? 'mobile' : 'web'}`]}`}>

                {rtm.map((event: SystemRTM, index: number) =>
                {
                    const { eventKindType, timestamp, softwareDeviceType, unknownElement } = event;
                    const { translationKey } = eventDetails(eventKindType!, softwareDeviceType!);

                    const symbol = unknownElement ? 'Quest_unknown_DP' : getEventIcon(event);

                    const operateTarget = !isValidDeviceNumber(event.element) ? {
                        systemId: event.systemId!,
                        id: event.zone!,
                        properties1: event.properties1,
                        numberGroup: event.numberGroup!,
                        systemPlanId: event.systemPlanId,
                        rtm: [event]
                    } : {
                        systemId: event.systemId!,
                        id: event.element!,
                        groupId: event.zone!,
                        numberGroup: event.numberGroup!,
                        properties1: event.properties1,
                        systemPlanId: event.systemPlanId,
                        rtm: [event]
                    };

                    const description = t(translationKey);

                    const date = timestampToDate(timestamp!);
                    //const label = formatLogicalAddress(zone!, element!, panelNumber!);
                    const label = getLogicalAddress(event as unknown as Event);


                    /*let el = `${element}`;
    
                    if (element < 10) el = `00${element}`;
                    else if (element >= 10 && element < 100) el = `0${element}`;
                    */

                    const hasOperations = validOperations(authorizationLevel, operateTarget as OperateTarget).length && hasOperationAndPushLicense;
                    const isOnPlanView = Boolean(operateTarget.systemPlanId) && hasPlanLicense;
                    const hasMeasurements = permissionAllowed(permissions.permitAccessLevel3!) && operateTarget.rtm[0].providesMeasurements;

                    const onMenu = (e?: ReactClickEvent) =>
                    {
                        if (unknownElement) return;
                        if (hasMeasurements || isOnPlanView || hasOperations) presentOptions(operateTarget as OperateTarget, e);
                    };

                    return (<IonItem key={'event-item-' + index} className={eventItemStyle['event-container']}>


                        <IonCard {...LongPress(onMenu)} onContextMenu={onMenu} slot="start" className={eventItemStyle["event-card-start"]}>

                            <IonText className={eventItemStyle["event-fontsize-title"]}>{`${label}`}</IonText>

                            {!mobileView && !unknownElement && (hasMeasurements || isOnPlanView || hasOperations) ? (
                                <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                    <MenuComponent onClick={onMenu} />
                                    <div className={eventItemStyle["event-icon-wrapper"]}>
                                        <Icon height={30} width={30} icon={symbol as IconName} />
                                    </div>
                                </div>) : (<div className={eventItemStyle["event-icon-wrapper"]}>
                                    <Icon height={30} width={30} icon={symbol as IconName} />
                                </div>)}
                        </IonCard>

                        <div style={{ width: "100%", height: "100%" }} {...LongPress(onMenu)} onContextMenu={onMenu}>
                            <div style={{ display: "flex" }}>
                                <div style={{ flexGrow: 1, display: "flex" }}>
                                    <div style={{ flexGrow: 1 }}>
                                        <IonText>{t(description)}</IonText>
                                        <EventDetails event={event} permissions={permissions} />
                                    </div>
                                    <div style={{ flexGrow: 0 }}>
                                        <div className={eventItemStyle["align-right"]}>
                                            <IonText>{formatDate(date, { "timezone": 'UTC', "dateStyle": "medium" })}</IonText>
                                        </div>
                                        <div className={eventItemStyle["align-right"]}>
                                            <IonText>{formatDate(date, { "timeZone": 'UTC', "timeStyle": "medium" })}</IonText>
                                        </div>
                                    </div>
                                </div>
                                {mobileView && <div style={{ width: "2em", display: "flex", alignItems: "top", paddingTop: ".5em", justifyContent: "end" }}>
                                    {!unknownElement && (hasMeasurements || isOnPlanView || hasOperations) ?
                                        <MenuComponent onClick={onMenu} /> : <></>
                                    }
                                </div>}

                            </div>
                        </div>

                    </IonItem>);
                })}

            </IonList>
            {children}
        </IonList >
    </>;
};


export { EventItem };
